import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d90a5aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-gerund-color" }
const _hoisted_2 = { class: "success-details-bg pb-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_SuccessContent = _resolveComponent("SuccessContent")!
  const _component_AwardWinningAgency = _resolveComponent("AwardWinningAgency")!
  const _component_SuccessStoryDetails = _resolveComponent("SuccessStoryDetails")!
  const _component_AwardWinning = _resolveComponent("AwardWinning")!
  const _component_TestimonialsContent = _resolveComponent("TestimonialsContent")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, {
      class: "bg-transparent fixed-top border-bottom",
      mwClass: "",
      className: "m-auto"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SuccessContent),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AwardWinningAgency),
        _createVNode(_component_SuccessStoryDetails)
      ])
    ]),
    _createVNode(_component_AwardWinning),
    _createVNode(_component_TestimonialsContent),
    _createVNode(_component_MainFooter)
  ], 64))
}